/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  ReverseRegistrar,
  ReverseRegistrarInterface,
} from "../../../contracts/reverseRegistrar/ReverseRegistrar";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract Registry",
        name: "_registry",
        type: "address",
      },
      {
        internalType: "contract Resolver",
        name: "_resolver",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [],
    name: "ReverseRegistrarUnequalArrayLengths",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "registry",
        type: "address",
      },
    ],
    name: "LogSetRegistry",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "resolver",
        type: "address",
      },
    ],
    name: "LogSetResolver",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "node",
        type: "bytes32",
      },
    ],
    name: "ReverseClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "ADDR_REVERSE_NODE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LOOKUP",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OPERATOR_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string[]",
        name: "names",
        type: "string[]",
      },
      {
        internalType: "address[]",
        name: "owners",
        type: "address[]",
      },
      {
        internalType: "bool[]",
        name: "isPrimary",
        type: "bool[]",
      },
    ],
    name: "batchSetName",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "node",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "registry",
    outputs: [
      {
        internalType: "contract Registry",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "resolver",
    outputs: [
      {
        internalType: "contract Resolver",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "setName",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_registry",
        type: "address",
      },
    ],
    name: "setRegistry",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_resolver",
        type: "address",
      },
    ],
    name: "setResolver",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type ReverseRegistrarConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ReverseRegistrarConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ReverseRegistrar__factory extends ContractFactory {
  constructor(...args: ReverseRegistrarConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _registry: AddressLike,
    _resolver: AddressLike,
    operator: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _registry,
      _resolver,
      operator,
      overrides || {}
    );
  }
  override deploy(
    _registry: AddressLike,
    _resolver: AddressLike,
    operator: AddressLike,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _registry,
      _resolver,
      operator,
      overrides || {}
    ) as Promise<
      ReverseRegistrar & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): ReverseRegistrar__factory {
    return super.connect(runner) as ReverseRegistrar__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ReverseRegistrarInterface {
    return new Interface(_abi) as ReverseRegistrarInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ReverseRegistrar {
    return new Contract(address, _abi, runner) as unknown as ReverseRegistrar;
  }
}
